<template>
  <svg
    class="lh-iconfont"
    :style="style"
    aria-hidden="true"
  >
    <use :xlink:href="name"></use>
  </svg>
</template>

<script>
export default {
  name: 'Iconfont',
  props: {
    name: {
      type: String,
      default: '#icon-video-stop'
    },
    fontSize: {
      type: String,
      default: '12px'
    }
  },
  computed: {
    style() {
      return {
        'font-size': this.fontSize
      };
    }
  }
};
</script>

<style scoped lang="scss">
/* @import url(); 引入css类 */
.lh-iconfont {
  width: 1em;
  height: 1em;
  /* 图标和文字相邻时，垂直对齐 */
  // vertical-align: -0.15em;
  /* 通过设置 color 来改变 SVG 的颜色/fill */
  fill: currentColor;
  /* path 和 stroke 溢出 viewBox 部分在 IE 下会显示
        normalize.css 中也包含这行 */
  overflow: hidden;
}
</style>
